const isMaxKBSize = (str, max) => {
  // 2 bytes per character
  return str.length * 2 / 1000 > max;
};
export { isMaxKBSize as default };
//# sourceMappingURL=isMaxKBSize.js.map
